// test2421
(2421 && 0);
